export default "__VITE_ASSET__ByGcnBSn__"